// The internal tools on the Tools page, one card each. `id` is the API's tool
// (GET /admin/tool-release/:id), which says where its releases live; the rest
// is how the card presents it. Adding a tool: an entry here, its icon under
// public/assets/tools/, and the tool in the API's toolRelease/enums.js.
export const TOOLS = [
  {
    id: 'rabbit',
    name: 'Zebel Rabbit',
    icon: '/assets/tools/rabbit.svg',
    description:
      "Describe a bulk change to a customer's account, or drop in a contractor's cost spreadsheet. An agent plans every API request, you review them, and only then does it run. Always acts on production.",
    // It offers newer releases itself, so a download is needed once.
    selfUpdates: true,
    afterInstall: 'Then sign in under Settings: your Zebel token and your Claude account.'
  },
  {
    id: 'radar',
    name: 'Zebel Radar',
    icon: '/assets/tools/radar.svg',
    description:
      'Sales intelligence for general contractors: a map of target GCs, the people there, and the paths in through our customers and their projects. The app opens the shared Radar and runs its research with your own Claude account.',
    // It doesn't offer upgrades yet: a newer release is a fresh download from here.
    afterInstall: 'Then sign in with your Google account (Jake adds you to the access list) and sign in to Claude under Settings › Claude. Download again here for newer versions.'
  }
];

// The computers a release can be for, as the API names them.
export const PLATFORMS = {
  mac: {
    label: 'macOS',
    detail: 'Apple Silicon (M1 or later)',
    // It isn't signed yet, so macOS blocks the first open; right-click › Open stopped working in
    // macOS 15, Open Anyway works everywhere.
    install: (name) =>
      `Mac: open the DMG, drag ${name} to Applications and open it. When macOS says Apple could not verify it, click Done, then go to System Settings › Privacy & Security, scroll down and click Open Anyway.`
  },
  windows: {
    label: 'Windows',
    detail: 'Windows 10 or 11, 64-bit',
    install: () => 'Windows: run the installer. If SmartScreen stops it, click More info, then Run anyway.'
  }
};
